
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/trend-finder",
      function () {
        return require("private-next-pages/[league]/trend-finder/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/trend-finder"])
      });
    }
  